import { Search } from "@/shared/ui/search"
import { Select } from "@/shared/ui/select/select"
import { FC } from "react"
import { AttractedStatusFilter, BlockStatusFilter, DeletedStatusFilter } from "@/shared/api/users"

const blockStatusOptions: { value: BlockStatusFilter; label: string }[] = [
    { value: 'all', label: 'Все' },
    { value: 'active', label: 'Активные' },
    { value: 'blocked', label: 'Заблокированные' }
]

const deletedStatusOptions: { value: DeletedStatusFilter; label: string }[] = [
    { value: 'active', label: 'Не удалённые' },
    { value: 'deleted', label: 'Удалённые' },
    { value: 'all', label: 'Все' }
]

const attractedStatusOptions: { value: AttractedStatusFilter; label: string }[] = [
    { value: 'all', label: 'Все' },
    { value: 'attracted', label: 'Привлечённые по ссылке' },
    { value: 'not_attracted', label: 'Не привлечённые по ссылке' }
]

interface UsersFiltersProps {
    setSearch: (arg0: string) => void
    search: string | null
    blockStatus?: BlockStatusFilter
    setBlockStatus?: (arg0: BlockStatusFilter) => void
    deletedStatus?: DeletedStatusFilter
    setDeletedStatus?: (arg0: DeletedStatusFilter) => void
    attractedStatus?: AttractedStatusFilter
    setAttractedStatus?: (arg0: AttractedStatusFilter) => void
}

export const UsersFilters: FC<UsersFiltersProps> = ({ search, setSearch, blockStatus, setBlockStatus, deletedStatus, setDeletedStatus, attractedStatus, setAttractedStatus }) => {
    return (
        <div className="grid grid-cols-12 gap-2">
            <div className="col-span-12 sm:col-span-6 xxl:col-span-4">
                <Search value={search} onChange={setSearch} />
            </div>
            {blockStatus !== undefined && setBlockStatus && (
                <div className="col-span-12 sm:col-span-6 xxl:col-span-4">
                    <Select
                        value={blockStatus}
                        onChange={setBlockStatus}
                        options={blockStatusOptions}
                        placeholder="Статус блокировки"
                    />
                </div>
            )}
            {deletedStatus !== undefined && setDeletedStatus && (
                <div className="col-span-12 sm:col-span-6 xxl:col-span-4">
                    <Select
                        value={deletedStatus}
                        onChange={setDeletedStatus}
                        options={deletedStatusOptions}
                    />
                </div>
            )}
            {attractedStatus !== undefined && setAttractedStatus && (
                <div className="col-span-12 sm:col-span-6 xxl:col-span-4">
                    <Select
                        value={attractedStatus}
                        onChange={setAttractedStatus}
                        options={attractedStatusOptions}
                    />
                </div>
            )}
        </div>
    )
}
